import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Checkbox, TableHead as MuiTableHead, TableCell, TableRow } from '@mui/material';
import React from 'react';
export function TableHead({ columns, indeterminate, allItemsSelected, handleSelectAllClick, }) {
    return (React.createElement(MuiTableHead, null,
        React.createElement(TableRow, { sx: {
                alignItems: 'center',
                borderBottom: `1px solid ${themeColors.border.main}`,
                display: 'flex',
                gap: 2,
                py: 2,
                width: '100%',
            } },
            React.createElement(TableCell, { padding: 'checkbox', sx: { borderBottom: 'none' } },
                React.createElement(Checkbox, { color: 'primary', indeterminate: indeterminate, checked: allItemsSelected, onChange: handleSelectAllClick })),
            columns.map((column, index) => {
                if (index === 0) {
                    return (React.createElement(TableCell, { key: index, component: 'th', scope: 'row', sx: {
                            display: 'flex',
                            width: '100%',
                            maxWidth: column.maxWidth,
                            borderBottom: 'none',
                            p: 0,
                        } }, column.label));
                }
                return (React.createElement(TableCell, { key: index, align: 'left', sx: {
                        display: 'flex',
                        width: '100%',
                        maxWidth: column.maxWidth,
                        borderBottom: 'none',
                        p: 0,
                    } }, column.label));
            }))));
}
